import React, { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react"; // İstersen başka bir ikon da kullanabilirsin

const ScrollToTopButton: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      setIsVisible(window.scrollY > 300);
    };

    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  if (!isVisible) return null;

  return (
    <button
      onClick={scrollToTop}
    className="fixed bottom-2 left-1/2 transform -translate-x-1/2 z-50 bg-blue-600 hover:bg-blue-700 text-white p-3 rounded-full shadow-lg transition duration-300"

      aria-label="Yukarı Çık"
    >
      <ArrowUp size={20} />
    </button>
  );
};

export default ScrollToTopButton;
